import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { hidden: "" }
const _hoisted_2 = {
  ref: "video",
  autoplay: ""
}
const _hoisted_3 = ["width", "height"]
const _hoisted_4 = { ref: "image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("video", _hoisted_2, null, 512),
    _createElementVNode("canvas", {
      ref: "canvas",
      width: _ctx.canvasObj.WIDTH,
      height: _ctx.canvasObj.HEIGHT
    }, null, 8, _hoisted_3),
    _createElementVNode("img", _hoisted_4, null, 512)
  ]))
}